import { PRIMARY_RED } from "constants/colors";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import {
  Alert,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row
} from 'reactstrap';
import { createSelector } from "reselect";
import * as Yup from "yup";
import logoLight from "../../assets/images/logo-light.png"; // Make sure this path is correct

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      dispatch({ type: "LOGIN_USER", payload: { values, navigate } });
    }
  });

  const selectLoginState = (state) => state.Login;
  const LoginProperties = createSelector(
    selectLoginState,
    (login) => ({
      error: login.error
    })
  );

  const { error } = useSelector(LoginProperties);

  return (
    <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div style={{ width: "100%", maxWidth: "500px" }}>
        <Card className="overflow-hidden shadow">
          <CardBody>
            {/* Logo */}
            <div className="text-center mb-4">
              <img src={logoLight} alt="Logo" height="50" />
            </div>

            {/* Welcome Text */}
            <div className="p-3">
              <h4 className="text-muted font-size-18 mb-1 text-center">Welcome Back !</h4>

              <Form
                className="form-horizontal mt-4"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                }}
              >
                {/* Error Message */}
                {error ? <Alert color="danger">{error}</Alert> : null}

                {/* Email */}
                <div className="mb-3">
                  <Label htmlFor="username">Username</Label>
                  <Input
                    name="email"
                    placeholder="Enter email"
                    type="email"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email || ""}
                    invalid={validation.touched.email && validation.errors.email ? true : false}
                  />
                  {validation.touched.email && validation.errors.email && (
                    <FormFeedback>{validation.errors.email}</FormFeedback>
                  )}
                </div>

                {/* Password */}
                <div className="mb-3">
                  <Label htmlFor="userpassword">Password</Label>
                  <Input
                    name="password"
                    value={validation.values.password || ""}
                    type="password"
                    placeholder="Enter Password"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={validation.touched.password && validation.errors.password ? true : false}
                  />
                  {validation.touched.password && validation.errors.password && (
                    <FormFeedback>{validation.errors.password}</FormFeedback>
                  )}
                </div>

                {/* Remember & Login Button */}
                <Row className="mb-3 mt-4">
                  <Col xs={6}>
                    <div className="form-check">
                      <input type="checkbox" className="form-check-input" id="customControlInline" />
                      <label className="form-check-label" htmlFor="customControlInline">Remember me</label>
                    </div>
                  </Col>
                  <Col xs={6} className="text-end">
                    <button
                      className="btn btn-primary w-md waves-effect waves-light"
                      style={{ backgroundColor: PRIMARY_RED }}
                      type="submit"
                    >
                      Log In
                    </button>
                  </Col>
                </Row>
              </Form>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default Login;
